export default "<div class=\"forge-main-content\">\n<p>The page you're looking for could not be found.</p>\n</div>"